import { observable, action, computed } from "mobx";
import { post } from "../services/ajax.service";

class RxValetInternationalStore {
  
  @observable rxValetInternational = {};
  @observable rxValetInternationalList = [];
  @observable count = 0;
  @observable url = "/api/v1/recommendationactions/RxValetInternational";

  @computed get tiles() {
    return parseInt(this.count % 100) > 0 ? parseInt(this.count / 100) + 1 : parseInt(this.count / 100);
  }
 
  @action getRxValetInternational = async (data) => {
    this.rxValetInternational = {};
    try {
      let response = await post(
        `${this.url}/getRxValetInternational`,
        data
      );

      this.rxValetInternational = response.data[0];
    } catch (err) {
      console.log(err);
    }
  }

  @action getRxValetInternationalCount = async (data) => {
    this.count = 0;
    try {
      let response = await post(
        `${this.url}/getRxValetInternationalCount`,
        data
      );

      this.count = response.data[0].count;
    } catch (err) {
      console.log(err);
    }
  }
  @action getRxValetInternationalList = async (data) => {
    this.rxValetInternationalList = [];
    try {
      let response = await post(
        `${this.url}/getRxValetInternationalList`,
        data
      );

      this.rxValetInternationalList = response.data;
    } catch (err) {
      console.log(err);
    }
  }
  


}

export default RxValetInternationalStore;
